import styles from './PageHeader.module.scss';
import RefreshButton from '@casops/components/inputs/refresh-button/RefreshButton';
import { ReactElement, ReactNode } from 'react';
import { TagDescription } from '@reduxjs/toolkit/query';
import { QueryTag } from '@casops/store/api';

interface PageHeaderProps {
  title: string;
  tagsToClearOnRefresh?: TagDescription<QueryTag>[];
  isRefreshDisabled?: boolean;
  children?: ReactNode;
}

export function PageHeader({
  title,
  tagsToClearOnRefresh,
  isRefreshDisabled,
  children,
}: PageHeaderProps): ReactElement {
  return (
    <header className={styles.header}>
      <div>{title}</div>
      <div className={styles.children}>
        {children}
        {tagsToClearOnRefresh && (
          <RefreshButton tagsToClear={tagsToClearOnRefresh} disabled={isRefreshDisabled} />
        )}
      </div>
    </header>
  );
}

export default PageHeader;
